/**
 * cart-bundle-images.js
 *
 * Reads kbx_box_image / _bundle_image from /cart.js (the cart API returns ALL
 * properties, including underscore-prefixed ones that Liquid strips) and
 * updates the <img class="cart-item__image"> inside each matching cart row.
 *
 * Why this is needed:
 * - Shopify Liquid item.properties does NOT expose underscore-prefixed Cart
 *   Transform attributes (e.g. _bundle_image).
 * - linesMerge.image.url does NOT update item.image in Liquid templates.
 * - The non-underscore kbx_box_image attribute (added in v89) IS accessible
 *   in Liquid, but older cart items may lack it — this JS handles both cases.
 *
 * Observer strategy:
 * - #CartDrawer (the stable outer div) is observed with childList:true.
 *   When cart-drawer.js calls sectionElement.innerHTML=... it replaces the
 *   direct children of #CartDrawer, firing this observer reliably.
 *   Observing #CartDrawer-CartItems would FAIL because that inner element is
 *   destroyed and recreated on every re-render, detaching any observer on it.
 */
(function () {
  'use strict';

  function updateBundleImages() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) return;
        cart.items.forEach(function (item, i) {
          var props = item.properties || {};
          var bundleImg =
            props['kbx_box_image'] ||
            props['_bundle_image'] ||
            null;
          if (!bundleImg) return;

          // Dawn renders each cart row with data-line="{{ index + 1 }}" (1-based)
          var row = document.querySelector('[data-line="' + (i + 1) + '"]');
          if (!row) return;

          var img = row.querySelector('.cart-item__image');
          if (!img) return;

          if (img.src !== bundleImg) {
            img.src = bundleImg;
            img.removeAttribute('srcset');
          }
        });
      })
      .catch(function () {});
  }

  // ── Hooks ──────────────────────────────────────────────────────────────────

  // 1. Cart page initial render
  document.addEventListener('DOMContentLoaded', updateBundleImages);

  // 2. After theme dispatches cart:updated (quantity changes, etc.)
  document.addEventListener('cart:updated', updateBundleImages);

  // 3. Watch the STABLE #CartDrawer outer div for direct-child DOM changes.
  //    cart-drawer.js does: document.querySelector('#CartDrawer').innerHTML = ...
  //    which replaces direct children → this fires reliably on every re-render.
  //    (Do NOT observe #CartDrawer-CartItems — it is recreated on every render.)
  function setupObservers() {
    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      new MutationObserver(function () {
        updateBundleImages();
      }).observe(cartDrawer, { childList: true, subtree: false });
    }

    // Cart page container (#main-cart-products) is stable — safe to observe directly
    var mainCart = document.getElementById('main-cart-products');
    if (mainCart) {
      new MutationObserver(function () {
        updateBundleImages();
      }).observe(mainCart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObservers);
  } else {
    setupObservers();
  }
})();

